import React, { useState, useEffect } from "react";

const SchoolsTable = () => {
  const [rawSchoolData, setRawSchoolData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/schools`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setRawSchoolData(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSchools();
  }, []);

  const processedSchoolData = rawSchoolData.map((item) => {
    return {
      schoolName: item["School"] || "-",
      nameOfHead: item["Name of Head"] || "-",
      phoneNo: item["Phone No."] || "-",
      address: item["Address"] || "-",
    };
  });

  if (loading) {
    return (
      <div className="text-center p-4 text-gray-700">
        Loading school data...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-4 text-red-600 font-bold">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="schools-table-container p-6 bg-gray-100 min-h-screen font-inter">
      <h2 className="text-3xl font-bold text-center mb-6 text-gray-800 rounded-md bg-white p-4 shadow-md">
        School Directory
      </h2>
      <div className="table-responsive overflow-x-auto rounded-lg shadow-lg bg-white">
        {" "}
        {/* Added overflow-x-auto here */}
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider rounded-tl-lg"
              >
                School
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Name of Head
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Phone No.
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider rounded-tr-lg"
              >
                Address
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {processedSchoolData.length > 0 ? (
              processedSchoolData.map((school, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors duration-200 ease-in-out"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                    {school.schoolName}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                    {school.nameOfHead}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                    {school.phoneNo}
                  </td>
                  {/* Removed whitespace-nowrap from address to allow text wrapping */}
                  <td className="px-6 py-4 text-sm text-gray-800">
                    {school.address}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-6 py-4 text-center text-gray-500">
                  No school data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SchoolsTable;
